import React from 'react';

// Types
import { FormTypeType } from 'Shared/types/ReviewFormTemplate.type';

// Utils
import * as ReviewsUtils from 'Shared/utils/Reviews.utils';

// Helpers
import * as ReviewFormHelpers from 'Shared/model_helpers/ReviewForm.helper';
import * as ReviewFormTemplatesHelpers from 'Shared/model_helpers/ReviewFormTemplates.helper';

// Hooks
import { useReview } from 'Shared/utils/hooks/use-review';
import { useUser } from 'Shared/utils/hooks/use-user';

// Components
import { WpText } from 'Wpds/components/text';
import { WpContainer, WpContainerBody } from 'Wpds/components/container';
import { WpAvatar } from 'Wpds/components/avatar';
import ReviewForm from '../../ThreeSixtyReviewPartials/ReviewForm/ReviewForm';

// Styles
import './ManagerReviewFormContainer.scss';

type Props = {
  reviewSlug: string;
  inContainer?: boolean;
};

const ManagerReviewFormContainer = ({ reviewSlug, inContainer = true }: Props) => {
  const { review, managerReviewForm } = useReview({ slug: reviewSlug });
  const userSlug = ReviewFormHelpers.getUserSlug(managerReviewForm);

  const { user: manager } = useUser({ slug: userSlug });
  const formSlug = ReviewFormHelpers.getSlug(managerReviewForm);
  const formData = ReviewFormHelpers.getFormData(managerReviewForm);

  const template = ReviewsUtils.getFormTemplateForForm({
    review,
    templateFormType: FormTypeType.manager_peer_review,
  });
  const questions = ReviewFormTemplatesHelpers.getQuestions(template);

  const answers = ReviewFormHelpers.getAnswers(managerReviewForm);

  const reviewForm = (
    <ReviewForm questions={questions} answers={answers?.toJS()} formData={formData} formSlug={formSlug} />
  );

  const baseClassName = 'ManagerReviewFormContainer';

  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__header`}>
        <div className={`${baseClassName}__header__avatar`}>
          <WpAvatar avatar={manager.avatar} />
        </div>
        <WpText tag="h5" variant="bodyXl" bold noMargin>
          {manager.fullName}{' '}
          <WpText tag="span" variant="bodyXl" noMargin>
            (manager)
          </WpText>
        </WpText>
      </div>
      {inContainer ? (
        <WpContainer>
          <WpContainerBody>{reviewForm}</WpContainerBody>
        </WpContainer>
      ) : (
        reviewForm
      )}
    </div>
  );
};

export default ManagerReviewFormContainer;
